// @ts-nocheck
//TODO: fix the remaining issues
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { markerStyle } from './markerStyle.js';

const Marker = ({ lat, lng, isActive, selectDealer, name, indx }) => {
    const markerRef = useRef();

    if (!lat && !lng) {
        return null;
    }

    return (
        <div className={`dealer-page__marker${isActive ? '--active' : ''} `} style={markerStyle} onClick={() => selectDealer(name, indx)}>
            {false && isActive &&
                <span>{name}</span>}
        </div>
    );
};

export default React.memo(Marker);
